import { useParam } from "@blitzjs/next"
import { useQuery } from "@blitzjs/rpc"
import getDevicePropertiesSample from "app/applicationUsers/queries/getDevicePropertiesSample"
import getRecentEventNames from "app/applicationUsers/queries/getRecentEventNames"

type TUseDevicePropertiesProps = {
  applicationId?: number
}

const useDeviceProperties = (
  { applicationId: _applicationId }: TUseDevicePropertiesProps | undefined = {
    applicationId: undefined,
  }
) => {
  const paramApplicationId = useParam("applicationId", "number")!
  const applicationId = _applicationId || paramApplicationId

  const [_deviceProperties, ...rest] = useQuery(
    getDevicePropertiesSample,
    {
      applicationId,
    },
    {
      enabled: !!applicationId,
      suspense: false,
      staleTime: Infinity,
    }
  )

  const [recentEventNames] = useQuery(
    getRecentEventNames,
    {
      applicationId,
    },
    {
      suspense: false,
      enabled: !!applicationId,
      staleTime: Infinity,
    }
  )

  const deviceProperties = {
    ..._deviceProperties,
    ...(recentEventNames || []).reduce((acc, { name }) => {
      acc[`daysSince_${name}`] = 1
      return acc
    }, {}),
  }

  return [deviceProperties, ...rest]
}

export default useDeviceProperties as any
